import { styled } from '@linaria/react';
import { layout } from '../../theme/tokens';

export const HideOnMobile = styled.div`
  display: none;

  @media (min-width: ${layout.desktopBreakpoint}) {
    display: block;
    height: 100%;
  }
`;
